import { Form, Modal } from "react-bootstrap";
import { FiCopy, FiCalendar, FiRepeat } from "react-icons/fi";

const s = {
    modal: {
        borderRadius: 16,
        border: 'none',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
    },
    header: {
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        padding: '20px 24px 16px',
        position: 'relative',
    },
    closeBtn: {
        position: 'absolute',
        top: 14,
        right: 16,
        background: 'none',
        border: 'none',
        color: 'rgba(255,255,255,0.5)',
        fontSize: '1.3rem',
        cursor: 'pointer',
        lineHeight: 1,
        padding: 0,
    },
    title: {
        color: '#fff',
        fontSize: '1rem',
        fontWeight: 600,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        margin: 0,
    },
    subtitle: {
        display: 'inline-block',
        background: 'rgba(255,255,255,0.12)',
        color: '#a8c0e8',
        fontSize: '0.7rem',
        fontWeight: 600,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        padding: '3px 10px',
        borderRadius: 20,
        marginTop: 6,
    },
    body: {
        padding: '20px 24px',
        background: '#fff',
    },
    fieldGroup: {
        marginBottom: 14,
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        fontSize: '0.72rem',
        fontWeight: 700,
        letterSpacing: '0.07em',
        textTransform: 'uppercase',
        color: '#9ca3af',
        marginBottom: 6,
    },
    input: {
        width: '100%',
        padding: '8px 12px',
        borderRadius: 8,
        border: '1px solid #e5e7eb',
        fontSize: '0.875rem',
        color: '#1a1a2e',
        background: '#f8f9fb',
        outline: 'none',
    },
    footer: {
        padding: '12px 24px 16px',
        background: '#fff',
        borderTop: '1px solid #f0f2f5',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 8,
    },
    btnSecondary: {
        fontSize: '0.82rem',
        fontWeight: 600,
        padding: '7px 18px',
        borderRadius: 8,
        border: '1px solid #e5e7eb',
        background: '#fff',
        color: '#6b7280',
        cursor: 'pointer',
    },
    btnPrimary: {
        fontSize: '0.82rem',
        fontWeight: 600,
        padding: '7px 18px',
        borderRadius: 8,
        border: 'none',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #3b6fd4 100%)',
        color: '#fff',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
    },
};

const ModalCalendarTrainingCopy = (props) => {
    const handleCopyTraining = () => {
        props.setCopyTraining({
            pattern: document.querySelector('select[name="pattern"]').value,
            start_date: document.querySelector('input[name="start_date"]').value,
            team_id: !props.id ? document.querySelector('select[name="team_id"]').value : '',
        });
    };

    return (
        <Modal show={props.showModalCopy} onHide={props.handleCloseModal} aria-labelledby="modal-title" centered>
            <div style={s.modal}>
                {/* Header */}
                <div style={s.header}>
                    <button style={s.closeBtn} onClick={props.handleCloseModal}>×</button>
                    <p style={s.title}>Copia allenamento</p>
                    <span style={s.subtitle}>Replica su periodo</span>
                </div>

                {/* Body */}
                <div style={s.body}>
                    {!props.id && (
                        <div style={s.fieldGroup}>
                            <label style={s.label}>Team</label>
                            <Form.Select name="team_id" style={s.input}>
                                <option value="">Seleziona Team</option>
                                {props.team?.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
                            </Form.Select>
                        </div>
                    )}

                    <div style={s.fieldGroup}>
                        <label style={s.label}><FiRepeat size={11} /> Ripeti per</label>
                        <Form.Select name="pattern" style={s.input}>
                            <option value="">Scegli opzione</option>
                            <option value="week">Settimana</option>
                            <option value="month">Mese</option>
                        </Form.Select>
                    </div>

                    <div style={s.fieldGroup}>
                        <label style={s.label}><FiCalendar size={11} /> Data di partenza</label>
                        <input name="start_date" type="date" style={s.input} />
                    </div>
                </div>

                {/* Footer */}
                <div style={s.footer}>
                    <button style={s.btnSecondary} onClick={props.handleCloseModal}>Chiudi</button>
                    <button style={s.btnPrimary} onClick={handleCopyTraining}>
                        <FiCopy size={13} /> Copia allenamento
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalCalendarTrainingCopy;
